import { render } from "./PLogin.vue?vue&type=template&id=f8716094&scoped=true"
import script from "./PLogin.vue?vue&type=script&lang=js"
export * from "./PLogin.vue?vue&type=script&lang=js"

import "./PLogin.vue?vue&type=style&index=0&id=f8716094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8716094"]])

export default __exports__